import { AnyAction } from 'redux';

import { InternalActionTypes } from '../constants/actionTypes';

export interface LogoutAction extends AnyAction {
  type: InternalActionTypes.Logout;
}

export function createLogoutAction(): LogoutAction {
  return {
    type: InternalActionTypes.Logout,
  };
}
